import * as _ from 'lodash';
import { Action, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { sanitizePii } from 'shared-react';
interface FormAction extends Action {
  meta: { form: string };
}
import { apis } from 'ui-common';

// Send a form failure event to pixel
function sendFormFailureEvent(
  action: FormAction,
  errors: Record<string, string | null | undefined>,
  isSyncError: boolean,
  labels?: Record<string, string>,
) {
  const { form } = action.meta;

  const formFailure = {
    form_name: form,
    is_sync_error: isSyncError,
    // We sanitize errors which could in theory contain pii as a safety measure
    errors: sanitizePii(errors),
  };

  apis.pixelAPI.createFormFailure({ event: formFailure, labels });
}

const pixelMiddleware: Middleware = (store: MiddlewareAPI<any>) => (next: Dispatch<any>) => (action: any) => {
  switch (action.type) {
    // We use this action to catch submit errors (async) because it includes the general error
    case '@@redux-form/STOP_SUBMIT': {
      const submitErrors = action.payload;

      // Not every STOP_SUBMIT contains a submit error (async).
      // Only send a form failure event when there is a submit error
      if (!_.isEmpty(submitErrors)) {
        sendFormFailureEvent(action, submitErrors, false, { app: 'login' });
      }
      break;
    }
    case '@@redux-form/SET_SUBMIT_FAILED': {
      const state = store.getState();
      const syncErrors = _.get(state, `form.${action.meta.form}.syncErrors`, {});

      // If there aren't sync errors we don't handle them here
      if (_.isEmpty(syncErrors)) break;

      sendFormFailureEvent(action, syncErrors, true, { app: 'login' });

      break;
    }
  }
  next(action);
};

export default pixelMiddleware;
